import React, {Component} from 'react'
import { makeRequest } from '../../utils/Storefront'

class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: props.email,
      showPassword: false,
      passwordError: null,
      message: null,
    }
  }

  getValues() {
    return {
      password: document.querySelector('[data-login-password]')?.value,
    }
  }

  updateState(e) {
    this.setState({
      message: null,
      passwordError: null,
    })
    const { password } = this.getValues()
    if(document.getElementById('login-customer-password')) document.getElementById('login-customer-password').value = password
  }
  sendRecoverEmail(e) {
    e.preventDefault()
    e.target.disabled = true
    const query = `
      mutation ($email: String!) {
        customerRecover(email: $email) {
          customerUserErrors {
            code
            field
            message
          }
        }
      }
    `
    const variables = {
      email: this.state.email,
    }
    
    makeRequest(
      (result) => {
        console.log(result)
        e.target.disabled = false
        if(result?.data?.customerRecover?.customerUserErrors?.length > 0) {
          this.setState({
            message: result?.data?.customerRecover?.customerUserErrors[0].message
          })
        } else {
          this.setState({
            message: result.errors ? result.errors[0].message : window.accountStrings.popup.recoverEmailSent
          })
        }
      },
      query,
      variables,
    )
  }

  submitData(e) {
    const { password } = this.getValues()
    if(!password) {
      this.setState({
        passwordError: window.accountStrings.popup.passwordRequired,
      })
    }
    const isValid = !!password
    if ((e.key === 'Enter' || e.target.id == 'loginSubmit') && isValid) {
      e.preventDefault()
      e.stopPropagation()
      document.getElementById('header_customer_login').submit()
    }
  }

  render() {
    return (
      <div>
        <div className="input-wrap mb-7.5">
          <input type={this.state.showPassword ? 'text' : 'password'} 
            className='' 
            id='LoginForm-password' 
            placeholder={window.accountStrings.popup.password}
            data-login-password 
            data-required 
            onInput={e => this.updateState(e)}
            onKeyDown={e => this.submitData(e)}
            onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
            onBlur={e => {
              e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target.value)
            }}
          />
          <label htmlFor="LoginForm-password" className=''>
            {window.accountStrings.popup.password}
          </label>
          {
            this.state.passwordError && <div className="absolute -bottom-4 left-0 text-[0.625rem]">{ this.state.passwordError }</div>
          }
          <div className='inline-flex items-center absolute bottom-3.75 right-3.75 z-2'>
            <button className='text-xs normal-case !text-tb-black' 
              onClick={e => {
                e.preventDefault()
                this.setState({ showPassword: !this.state.showPassword })
              }} 
              aria-label='Show Password'
            >
              { this.state.showPassword ? window.accountStrings.popup.hide : window.accountStrings.popup.show }
            </button>
            &nbsp;&ndash;&nbsp;
            <button className='text-xs normal-case !text-tb-black'
              onClick={ e => this.sendRecoverEmail(e) }
              aria-label='Forgot Password'
            >
              {window.accountStrings.popup.forgot}
            </button>
          </div>
        </div>
        <button className='button button--primary w-full mb-7.5' id='loginSubmit' onClick={e => this.submitData(e)}>
          {window.accountStrings.popup.login}
        </button>
        { this.state.message && <div className="text-xs mb-7.5">{ this.state.message }</div> }
      </div>
    )
  }
}

export default Login